import { Box, Stack, useToast } from '@chakra-ui/react'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import ButtonNavigation from 'components/button-navigation'
import ButtonPrimary from 'components/button-primary'
import Heading from 'components/heading'
import Input from 'components/input'
import NotificationToast from 'components/notification-toast'
import { useUserContext } from 'contexts/user-context'
import { updateUserAttributes } from 'utils/auth-utils'

import theme from 'theme'

export default function AccountProfileEditName() {
  const navigate = useNavigate()
  const toast = useToast()
  const { user, reloadUser } = useUserContext()
  const [firstName, setFirstName] = useState(user?.given_name ?? '')
  const [lastName, setLastName] = useState(user?.family_name ?? '')
  const [loading, setLoading] = useState(false)

  const saveFn = async () => {
    try {
      setLoading(true)
      await updateUserAttributes(firstName, lastName, user?.email ?? '')
      reloadUser()
      setLoading(false)
      navigate('/profile')
      toast({
        position: 'bottom',
        render: () => (
          <NotificationToast
            status="success"
            text="User details saved"
            onClose={() => {
              toast.closeAll()
            }}
          />
        ),
      })
    } catch (err) {
      console.error(err) // eslint-disable-line no-console
      setLoading(false)
      toast({
        position: 'bottom',
        render: () => (
          <NotificationToast
            status="error"
            text="There was an error saving your user details... Please try again"
            onClose={() => {
              toast.closeAll()
            }}
          />
        ),
      })
    }
  }

  return (
    <Stack
      w="100%"
      direction="column"
      spacing="32px"
      pt={4}
      px={{ base: 4, lg: 0 }}
      mx={{ base: 0, xl: 24 }}
      maxW="1280px"
      bgColor={theme.baseColors.background.default}
      borderTopRadius="base"
    >
      <Heading as="h1" text="Edit Name" />
      <Box>
        <ButtonPrimary
          text="Back"
          icon={{ source: ['far', 'chevron-left'] }}
          color={theme.baseColors.primary.main}
          onClick={() => navigate('/profile')}
        />
      </Box>
      <Input label={{ text: 'First Name' }} value={firstName} onChange={e => setFirstName(e.target.value)} />
      <Input label={{ text: 'Last Name' }} value={lastName} onChange={e => setLastName(e.target.value)} />
      <ButtonNavigation type="progress" text="Save" onClick={saveFn} isDisabled={loading} isLoading={loading} />
    </Stack>
  )
}
